import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function MaskLine({ children, delay = 0, className = "", innerClassName = "" }) {
  return (
    <motion.span
      className={`block overflow-hidden ${className}`}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-6% 0px" }}
    >
      <motion.span
        className={`block will-change-transform ${innerClassName}`}
        variants={{ hidden: { y: "112%" }, show: { y: "0%" } }}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
}

export function FadeUp({ children, delay = 0, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-4% 0px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ index, children, className = "" }) {
  return (
    <FadeUp className={`flex items-center gap-3 ${className}`}>
      <span className="h-2 w-2 shrink-0 bg-glow" aria-hidden="true" />
      <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-ice">
        {index} / {children}
      </p>
    </FadeUp>
  );
}

export function Strike({ children, delay = 0 }) {
  return (
    <motion.span
      className="relative inline-block"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-10% 0px" }}
    >
      {children}
      <motion.span
        aria-hidden="true"
        className="absolute left-0 top-1/2 h-[0.07em] w-full origin-left bg-glow"
        variants={{ hidden: { scaleX: 0 }, show: { scaleX: 1 } }}
        transition={{ duration: 0.9, delay, ease: EASE }}
      />
    </motion.span>
  );
}
